import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import ErrorDisplay from './ErrorDisplay.vue';
import {getClients} from '@/api/module/settings';
import Client from '@/model/Client';
import pinia from '@/plugins/pinia';
import {useSettings} from '@/store/settings';
import {computed, ref, watch} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientSelect',
  props: {
  showLabel: {
    type: Boolean,
    default: false,
  },
  useModel: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: [Number],
    default: useSettings(pinia).selectedSubsidiary,
  },
  customerId: {
    type: String,
    default: null,
  },
},
  emits: {
  'update:modelValue'(val: number) {
    return typeof val === 'number';
  },
},
  setup(__props, { expose: __expose, emit: __emit }) {

const settingsStore = useSettings();

const props = __props;

const emits = __emit;

const internalValue = computed({
  get() {
    if (props.useModel) {
      return props.modelValue;
    }
    return settingsStore.client!;
  },
  set(newVal: number) {
    if (props.useModel) {
      emits('update:modelValue', newVal);
      return;
    }
    settingsStore.client = newVal;
  },
});

const loading = ref(true);
const data = ref<Client[]>([]);
const error = ref<Error | null>(null);

function loadData() {
  loading.value = true;
  if (props.customerId === undefined) {
    data.value = [];
    loading.value = false;
    error.value = null;
    return;
  }
  getClients({customerId: props.customerId})
      .then(([d]) => {
        data.value = d;
        error.value = null;
      })
      .catch((e) => {
        error.value = e;
        data.value = [];
      })
      .finally(() => loading.value = false);
}
loadData();
watch(() => props.customerId, () => {
  loadData();
});
__expose({
  internalValue,
  ErrorDisplay,
  loading, data, error,
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (error.value)
    ? (_openBlock(), _createBlock(ErrorDisplay, {
        key: 0,
        message: error.value?.message,
        loading: loading.value,
        onRetry: loadData
      }, null, 8, ["message", "loading"]))
    : (_openBlock(), _createBlock(_component_v_select, {
        key: 1,
        variant: !__props.showLabel ? 'solo' : undefined,
        density: !__props.showLabel ? 'compact' : 'default',
        label: "Mandant",
        "hide-details": "",
        class: "mt-3 mb-2",
        modelValue: internalValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
        "item-title": "Name",
        "item-value": "MandantNr",
        items: data.value,
        loading: loading.value,
        placeholder: "--- Mandant wählen ---",
        "return-object": false
      }, null, 8, ["variant", "density", "modelValue", "items", "loading"]))
}
}

})